import axios from 'axios'

import { HTTP_STATUS } from '../constants/httpStatus'
import { getAuthToken } from '../utils/getAuthToken'

export const createBridgeClient = (
  baseURL: string,
  apiBaseURL: string,
  bridgeApiKey: string,
  options?: { skipAuthentication?: boolean },
) => {
  const apiClientBridge = axios.create({ baseURL: apiBaseURL })

  /**
   * Axios interceptor will automatically attach the authentication token to the Authorization header of each request if it exists
   * If a response is received with a 401 Unauthorized status, the user will be redirected to the logout page to clear any invalid session and prompt for re-authentication
   */
  apiClientBridge.interceptors.request.use((config) => {
    config.headers = config.headers ?? {}

    if (!options?.skipAuthentication) {
      const authToken = getAuthToken(baseURL)

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`
      }
    }

    if (bridgeApiKey) {
      config.headers['x-api-key'] = bridgeApiKey
    }

    return config
  })

  if (!options?.skipAuthentication) {
    apiClientBridge.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
          window.location.href = '/logout'
        }
        return Promise.reject(error)
      },
    )
  }

  return apiClientBridge
}
